// Bảng danh sách API key + 2 thao tác: thu hồi (giữ lịch sử) và xoá hẳn (dọn bảng).
import React from "react";
import { Table, Button, Tag, Tooltip, Popconfirm, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faTrash } from "@fortawesome/free-solid-svg-icons";

const formatTime = (ts) => (ts ? new Date(Number(ts)).toLocaleString("vi-VN") : "—");

/** Tên tài khoản: có tên thì lấy tên, không thì email — trước đây rơi thẳng về "?". */
const ownerLabel = (row) => `${row.userName || row.userEmail || "(không tên)"} #${row.userId}`;

export default function ApiKeyTable({ keys, loading, scopeLabels, utilityScope, onRevoke, onDelete }) {
    const columns = [
        { title: "Tên", dataIndex: "name", render: (v) => <span className="font-medium">{v}</span> },
        { title: "Tài khoản", render: (_, r) => ownerLabel(r) },
        {
            title: "Phạm vi",
            render: (_, r) => (
                <Space size={4} wrap>
                    <Tag color={r.scope === utilityScope ? "purple" : "blue"} className="!mr-0">
                        {scopeLabels[r.scope] || r.scope}
                    </Tag>
                    {/* Trước đây 2 thẻ dính liền nhau đọc thành "Tiện ích gửi thông báoyt" */}
                    {r.site ? <Tag className="!mr-0">{r.site}</Tag> : null}
                </Space>
            ),
        },
        {
            title: "Key",
            dataIndex: "preview",
            render: (v) => <code className="text-xs bg-gray-100 px-1 py-0.5 rounded">{v}</code>,
        },
        { title: "Tạo lúc", render: (_, r) => formatTime(r.createdAt) },
        {
            title: "Dùng gần nhất",
            // Key chưa dùng lần nào ≠ key chết — nói rõ thay vì để dấu gạch trơ trọi.
            render: (_, r) =>
                r.lastUsedAt ? (
                    formatTime(r.lastUsedAt)
                ) : (
                    <span className="text-gray-400">chưa dùng lần nào</span>
                ),
        },
        {
            title: "Trạng thái",
            render: (_, r) =>
                r.revokedAt ? (
                    <Tooltip title={`Thu hồi lúc ${formatTime(r.revokedAt)}`}>
                        <Tag color="red">Đã thu hồi</Tag>
                    </Tooltip>
                ) : (
                    <Tag color="green">Đang dùng</Tag>
                ),
        },
        {
            title: "",
            render: (_, r) => (
                <Space size={0}>
                    {!r.revokedAt && (
                        <Popconfirm
                            title="Thu hồi key này?"
                            description="Bên ngoài đang dùng sẽ ngừng gọi được ngay. Dòng vẫn nằm lại để tra lịch sử."
                            okText="Thu hồi"
                            cancelText="Huỷ"
                            onConfirm={() => onRevoke(r.id)}
                        >
                            <Button danger type="text" title="Thu hồi" icon={<FontAwesomeIcon icon={faBan} />} />
                        </Popconfirm>
                    )}
                    <Popconfirm
                        title="Xoá hẳn key này?"
                        // Xoá key ĐANG SỐNG cắt luôn kết nối bên ngoài — phải nói khác nhau
                        // với xoá key đã thu hồi, không thì admin bấm theo quán tính.
                        description={
                            r.revokedAt
                                ? "Mất luôn lịch sử ai tạo / dùng lần cuối. Không khôi phục được."
                                : "Key ĐANG DÙNG: bên ngoài chết ngay lập tức và mất luôn lịch sử. Muốn giữ lịch sử thì thu hồi thay vì xoá."
                        }
                        okText="Xoá"
                        okButtonProps={{ danger: true }}
                        cancelText="Huỷ"
                        onConfirm={() => onDelete(r.id)}
                    >
                        <Button danger type="text" title="Xoá hẳn" icon={<FontAwesomeIcon icon={faTrash} />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Table
            rowKey="id"
            size="small"
            loading={loading}
            columns={columns}
            dataSource={keys}
            pagination={false}
            // Key đã thu hồi làm mờ: bảng dài thì mắt phải bắt ngay dòng nào còn sống.
            rowClassName={(r) => (r.revokedAt ? "opacity-50" : "")}
        />
    );
}
